import s from './ProgressRing.module.css';

const SIZE = 80;
const STROKE = 6;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export default function ProgressRing({ known, threshold, previousThreshold, size = SIZE, centerContent }) {
  const range = threshold - previousThreshold;
  const progress = range > 0 ? (known - previousThreshold) / range : 1;
  const clamped = Math.min(Math.max(progress, 0), 1);
  const offset = CIRCUMFERENCE * (1 - clamped);
  const charsToGo = Math.max(0, threshold - known);

  return (
    <div className={s.wrap} style={{ width: size, height: size }}>
      <svg viewBox={`0 0 ${SIZE} ${SIZE}`} className={s.ring}>
        <circle cx={SIZE/2} cy={SIZE/2} r={RADIUS} fill="none"
          stroke="var(--color-storybook-cream-800)" strokeWidth={STROKE} />
        <circle cx={SIZE/2} cy={SIZE/2} r={RADIUS} fill="none"
          stroke="var(--color-brand-orange)" strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
          className={s.progressArc}
          transform={`rotate(-90 ${SIZE/2} ${SIZE/2})`} />
      </svg>
      <div className={s.center}>
        {centerContent ?? (
          <>
            <span className={s.charsToGo}>{charsToGo}</span>
            <span className={s.label}>to go</span>
          </>
        )}
      </div>
    </div>
  );
}
